export default "__VITE_PUBLIC_ASSET__4304fbb8__"